"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var RotatePhone = function RotatePhone(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    width: "23",
    height: "25",
    viewBox: "0 0 23 25"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 16.5V21.268C13 21.6269 12.9293 21.9822 12.7919 22.3137C12.6546 22.6452 12.4533 22.9465 12.1995 23.2002C11.9457 23.4539 11.6444 23.6551 11.3128 23.7923C10.9812 23.9296 10.6259 24.0001 10.267 24H3.733C3.37414 24.0001 3.01878 23.9296 2.6872 23.7923C2.35562 23.6551 2.05433 23.4539 1.80054 23.2002C1.54674 22.9465 1.34542 22.6452 1.20806 22.3137C1.0707 21.9822 1 21.6269 1 21.268V5.733C1 5.00816 1.28794 4.31301 1.80048 3.80048C2.31301 3.28794 3.00816 3 3.733 3H8.5",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 19H13",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 6H22V1",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22 5.50082C21.6568 4.19184 20.8744 3.03529 19.7798 2.21861C18.6851 1.40194 17.3423 0.972997 15.969 1.00132C14.5956 1.02964 13.2722 1.51356 12.2133 2.37464C11.1544 3.23573 10.422 4.42352 10.1348 5.7455C9.84755 7.06748 10.0224 8.44617 10.6309 9.65813C11.2395 10.8701 12.2461 11.8443 13.4876 12.4228C14.7291 13.0013 16.1327 13.1503 17.471 12.8456C18.8093 12.5408 20.0038 11.8002 20.8609 10.7438",
    stroke: fill,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
RotatePhone.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
RotatePhone.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = RotatePhone;